/* ======================================================================== */
/* 86. loadSwiper */
/* ======================================================================== */
function loadSwiper() {

  return new Promise((resolve) => {
    let loaded = false;

    if (typeof window.Swiper === 'undefined' && !loaded) {

      elementorFrontend.on('components:init', () => {
        if (!loaded) {
          new elementorFrontend.utils.swiper(null, {}).then((instance) => {
            loaded = true;
            resolve(true);
          });
        }
      });

    } else {
      resolve(true);
    }
  });
}
